/* HD FX – Wow-Effekte: Intro, Cursor, weiches Scrollen, Decoder-Text, Szenen-Engine (ohne Bibliotheken) */
(function () {
  if (window.__HD_FX__) return;
  window.__HD_FX__ = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var design = document.documentElement.classList.contains('shopify-design-mode');
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function lerp(a, b, t) { return a + (b - a) * t; }

  /* 1. Intro: steuert sich selbst (sections/hd-intro.liquid) */

  /* ================= 2. Cursor-Glow (nur PC) ================= */
  if (fine && !reduce && !design) {
    var dot = document.createElement('div'); dot.className = 'hd-cursor-dot';
    var ring = document.createElement('div'); ring.className = 'hd-cursor-ring';
    var label = document.createElement('span'); ring.appendChild(label);
    document.body.appendChild(ring); document.body.appendChild(dot);
    var mx = innerWidth / 2, my = innerHeight / 2, rx = mx, ry = my, shown = false;
    window.addEventListener('pointermove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (!shown) { shown = true; document.body.classList.add('hd-cursor-on'); }
      dot.style.transform = 'translate3d(' + mx + 'px,' + my + 'px,0)';
    }, { passive: true });
    document.addEventListener('pointerleave', function () { document.body.classList.remove('hd-cursor-on'); shown = false; });
    document.addEventListener('pointerover', function (e) {
      var t = e.target.closest ? e.target.closest('[data-hd-cursor], a, button, summary, label, input, select') : null;
      ring.classList.toggle('is-hover', !!t);
      var txt = t && t.getAttribute('data-hd-cursor');
      if (!txt && t && t.matches('.hd-card__link, .hd-world__link')) txt = 'Ansehen';
      label.textContent = txt || '';
      ring.classList.toggle('has-label', !!txt);
    });
    (function loop() {
      rx = lerp(rx, mx, 0.18); ry = lerp(ry, my, 0.18);
      ring.style.transform = 'translate3d(' + rx.toFixed(1) + 'px,' + ry.toFixed(1) + 'px,0)';
      requestAnimationFrame(loop);
    })();
  }

  /* ================= 3. Weiches Scrollen (nur Mausrad am PC) ================= */
  if (fine && !reduce && !design) {
    var target = window.scrollY, current = window.scrollY, running = false;
    var maxScroll = function () { return document.documentElement.scrollHeight - innerHeight; };
    var scrollableParent = function (el) {
      while (el && el !== document.body) {
        var s = getComputedStyle(el);
        if (/(auto|scroll)/.test(s.overflowY) && el.scrollHeight > el.clientHeight) return el;
        el = el.parentElement;
      }
      return null;
    };
    /* Gebremste Bereiche (Hero + Sektionen mit data-hd-slow): langsamer scrollen und Höchstgeschwindigkeit,
       damit man die Animation nicht durchrauschen kann */
    var HERO_WHEEL = 0.35;     /* Mausrad im Hero deutlich langsamer */
    var HERO_MAX_VSEC = 1.67;  /* höchstens ~1,7 Sekunden Video pro Sekunde (unabhängig von 24/60 Bildern) */
    var HERO_MAX_AHEAD = 300;  /* höchstens so viele Pixel "auf Vorrat" */
    function heroZone(y) {
      var els = document.querySelectorAll('[data-hd-scroll-final], [data-hd-slow], [data-hd-scene="journey"]');
      for (var i = 0; i < els.length; i++) {
        var h = els[i];
        if (!h.offsetHeight) continue;
        var top = h.getBoundingClientRect().top + window.scrollY, travel = h.offsetHeight - innerHeight;
        if (travel <= 0 || y < top - 4 || y > top + travel + 4) continue;
        if (h.hasAttribute('data-hd-scroll-final')) {
          var dur = h.__hdDuration || ((h.__hdFrames && h.__hdFps) ? h.__hdFrames / h.__hdFps : 30);
          return { top: top, travel: travel, wheel: HERO_WHEEL, minSec: dur / HERO_MAX_VSEC };
        }
        /* data-hd-slow = Mindestdauer in Sekunden für den ganzen Bereich, data-hd-slow-wheel = Mausrad-Faktor */
        /* Versand-Reise ohne eigene Angabe: mindestens 9 Sekunden für alle 5 Schritte */
        return { top: top, travel: travel, wheel: Number(h.getAttribute('data-hd-slow-wheel')) || 0.6, minSec: Number(h.getAttribute('data-hd-slow')) || 9 };
      }
      return null;
    }
    var lastStep = 0;
    window.addEventListener('wheel', function (e) {
      if (e.ctrlKey || e.defaultPrevented || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      if (scrollableParent(e.target)) return;
      if (document.documentElement.classList.contains('hd-intro-lock')) { e.preventDefault(); return; }
      e.preventDefault();
      var d = e.deltaMode === 1 ? e.deltaY * 32 : e.deltaY;
      if (!running) { target = current = window.scrollY; }
      var zone = heroZone(current);
      if (zone) {
        d *= zone.wheel;
        target = clamp(target + d, current - HERO_MAX_AHEAD, current + HERO_MAX_AHEAD);
      } else {
        target = target + d;
      }
      target = clamp(target, 0, maxScroll());
      if (!running) { running = true; lastStep = performance.now(); requestAnimationFrame(step); }
    }, { passive: false });
    var step = function (now) {
      var dt = Math.min(0.05, Math.max(0.001, (now - lastStep) / 1000)); lastStep = now;
      var next = lerp(current, target, 1 - Math.pow(1 - 0.12, dt * 60));
      var zone = heroZone(current);
      if (zone) {
        /* beim Hineinscrollen keinen alten Schwung mitnehmen */
        target = clamp(target, current - HERO_MAX_AHEAD, current + HERO_MAX_AHEAD);
        next = lerp(current, target, 1 - Math.pow(1 - 0.12, dt * 60));
        var cap = zone.travel / zone.minSec * dt;
        if (Math.abs(next - current) > cap) next = current + (next > current ? cap : -cap);
      }
      current = next;
      if (Math.abs(target - current) < 0.5) current = target;
      window.scrollTo(0, current);
      if (current !== target) requestAnimationFrame(step); else running = false;
    };
    /* Andere Scroll-Quellen (Tastatur, Anker, Scrollbar) übernehmen */
    window.addEventListener('scroll', function () { if (!running) { target = current = window.scrollY; } }, { passive: true });
  }

  /* ================= 4. Decoder-Effekt für kleine Überschriften ================= */
  var glyphs = '!<>-_\\/[]{}—=+*^?#ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  function scramble(el) {
    if (el.__scr || reduce) return; el.__scr = true;
    var final = el.textContent, len = final.length, t0 = performance.now(), dur = 650, done = false;
    var end = function () { if (!done) { done = true; el.textContent = final; } };
    setTimeout(end, 1000); /* garantiert fertig, auch bei gedrosselten Frames */
    (function tick() {
      if (done) return;
      var k = Math.min(1, (performance.now() - t0) / dur), reveal = k * len, out = '';
      for (var i = 0; i < len; i++) out += (i < reveal || final[i] === ' ') ? final[i] : glyphs[(Math.random() * glyphs.length) | 0];
      el.textContent = out;
      if (k < 1) requestAnimationFrame(tick); else end();
    })();
  }
  if ('IntersectionObserver' in window) {
    var sio = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { scramble(e.target); sio.unobserve(e.target); } });
    }, { threshold: 0.6 });
    document.querySelectorAll('.hd-eyebrow, [data-hd-scramble]').forEach(function (el) { sio.observe(el); });
  }

  /* ================= 5. Zähler ================= */
  if ('IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        cio.unobserve(e.target);
        var el = e.target, to = Number(el.getAttribute('data-hd-count')), dur = 1600, t0 = performance.now();
        if (reduce) { el.textContent = to; return; }
        (function run(now) {
          var k = clamp((now - t0) / dur, 0, 1), eased = 1 - Math.pow(1 - k, 4);
          el.textContent = Math.round(to * eased);
          if (k < 1) requestAnimationFrame(run);
        })(t0);
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('[data-hd-count]').forEach(function (el) { cio.observe(el); });
  }

  /* ================= 6. Laufband reagiert auf Scroll-Tempo ================= */
  var tracks = [].slice.call(document.querySelectorAll('.hd-marquee__track'));
  var lastY = window.scrollY, vel = 0;

  /* ================= 7. Szenen-Engine (gepinnte Scroll-Storys) ================= */
  var scenes = [].slice.call(document.querySelectorAll('[data-hd-scene]'));
  window.HDScenes = window.HDScenes || {};

  function frame() {
    var y = window.scrollY, vh = innerHeight;
    vel = lerp(vel, Math.abs(y - lastY), 0.15); lastY = y;
    if (tracks.length && !reduce) {
      var rate = 1 + Math.min(vel / 6, 5);
      tracks.forEach(function (t) { var a = t.getAnimations && t.getAnimations()[0]; if (a) a.playbackRate = rate; });
    }
    scenes.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -50 || r.top > vh + 50) return;
      var p = el.__pOverride != null ? el.__pOverride : clamp(-r.top / Math.max(1, el.offsetHeight - vh), 0, 1);
      if (reduce || design) p = el.hasAttribute('data-hd-static-p') ? Number(el.getAttribute('data-hd-static-p')) : p;
      var fn = window.HDScenes[el.getAttribute('data-hd-scene')];
      if (el.__p === p && el.__fn === !!fn) return; el.__p = p; el.__fn = !!fn;
      el.style.setProperty('--p', p.toFixed(4));
      if (fn) fn(el, p);
      if (el.__after) el.__after(p);
    });
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);

  /* ================= 8. Handy/Tablet: Szenen Schritt für Schritt (jeder Wisch = ein Schritt) =================
     Mit dem Finger lässt sich das Scroll-Tempo nicht bremsen. Darum rastet die Sektion ein, jeder Wisch
     schaltet genau einen Schritt weiter und die Animation läuft in ihrem eigenen, ruhigen Tempo ab. */
  var coarse = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  if (coarse && !reduce && !design) {
    [].slice.call(document.querySelectorAll('[data-hd-scene="journey"], [data-hd-steps]')).forEach(stepper);
  }
  function stepper(el) {
    var n = Number(el.getAttribute('data-hd-steps')) || Number(getComputedStyle(el).getPropertyValue('--n')) || 5;
    var SPEED = 1 / 1.3;            /* ein Schritt dauert 1,3 Sekunden */
    var captured = false, step = 0, shownF = 0, targetF = 0, holdY = 0, y0 = null, raf = 0, last = 0, cool = 0, lastTop = null;
    function geo() { var r = el.getBoundingClientRect(); return { r: r, top: r.top + window.scrollY, travel: Math.max(1, el.offsetHeight - innerHeight) }; }
    /* Im Schritt-Modus immer nur die Szene des aktuellen Schritts zeigen (kein Mischbild beim Anhalten) */
    el.__after = function (p) {
      if (el.__pOverride == null) return;
      var f = p * n, cur = Math.max(0, Math.ceil(f - 1e-6) - 1);
      var scenes = el.querySelectorAll('.hd-jr__scene'), steps = el.querySelectorAll('.hd-jr__step'), nodes = el.querySelectorAll('.hd-jr__node');
      var fadeIn = cur === 0 ? 1 : clamp((f - cur) / 0.15, 0, 1);
      for (var i = 0; i < scenes.length; i++) scenes[i].style.opacity = (i === cur ? fadeIn : i === cur - 1 ? 1 - fadeIn : 0).toFixed(3);
      for (i = 0; i < steps.length; i++) { steps[i].classList.toggle('is-active', i === cur); steps[i].classList.toggle('is-done', i < cur); }
      for (i = 0; i < nodes.length; i++) nodes[i].classList.toggle('is-on', i <= cur);
      var day = el.querySelector('[data-jr-day]');
      if (day && steps[cur]) day.textContent = steps[cur].getAttribute('data-day');
    };
    function animate(now) {
      var dt = Math.min(0.05, Math.max(0.001, (now - last) / 1000)); last = now;
      var d = targetF - shownF, mv = SPEED * dt;
      shownF = Math.abs(d) <= mv ? targetF : shownF + (d > 0 ? mv : -mv);
      el.__pOverride = shownF / n;
      raf = shownF !== targetF ? requestAnimationFrame(animate) : 0;
    }
    function go(f) { targetF = clamp(f, 0, n); if (!raf) { last = performance.now(); raf = requestAnimationFrame(animate); } }
    function capture(fromAbove) {
      var g = geo();
      captured = true;
      holdY = Math.round(fromAbove ? g.top : g.top + g.travel);
      step = fromAbove ? 0 : n - 1;
      shownF = fromAbove ? 0 : n; el.__pOverride = shownF / n;
      window.scrollTo(0, holdY);   /* stoppt auch den Schwung des Wischens */
      go(step + 1);
    }
    function release(forward) {
      var g = geo();
      captured = false; cool = performance.now();
      if (raf) { cancelAnimationFrame(raf); raf = 0; }
      el.__pOverride = null;
      window.scrollTo(0, Math.round(forward ? g.top + g.travel + 2 : g.top - 2));
    }
    window.addEventListener('scroll', function () {
      var g = geo(), r = g.r;
      if (captured) { if (Math.abs(window.scrollY - holdY) > 1) window.scrollTo(0, holdY); return; }
      var pinned = r.top <= 0 && r.bottom >= innerHeight;
      if (pinned && lastTop !== null && performance.now() - cool > 450) capture(lastTop > r.top);
      lastTop = r.top;
    }, { passive: true });
    window.addEventListener('touchstart', function (e) { if (captured) y0 = e.touches[0].clientY; }, { passive: true });
    window.addEventListener('touchmove', function (e) { if (captured && e.cancelable) e.preventDefault(); }, { passive: false });
    window.addEventListener('touchend', function (e) {
      if (!captured || y0 === null) return;
      var dy = y0 - e.changedTouches[0].clientY; y0 = null;
      if (Math.abs(dy) < 30) return;                      /* Tippen, kein Wisch */
      if (Math.abs(targetF - shownF) > 0.35) return;      /* laufender Schritt ist noch nicht (fast) fertig */
      if (dy > 0) { if (step < n - 1) { step++; go(step + 1); } else release(true); }
      else { if (step > 0) { step--; go(step + 1); } else release(false); }
    }, { passive: true });
    /* Seite wird mitten in der Sektion geladen */
    var g0 = geo();
    if (g0.r.top <= 0 && g0.r.bottom >= innerHeight) {
      captured = true; holdY = Math.round(window.scrollY);
      step = Math.min(n - 1, Math.floor(clamp(-g0.r.top / g0.travel, 0, 1) * n));
      shownF = targetF = step + 1; el.__pOverride = shownF / n;
    }
    lastTop = g0.r.top;
  }
})();
